<div class="pdf-page app-cp-10-54-06-07" id="cp540607">
  <p class="font-small text-end">
    <b
      >COMMERCIAL PROPERTY<br />
      CP 10 54 06 07</b
    >
  </p>
  <p class="font-medium" style="text-align: center">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY</b>
  </p>
  <p class="font-large" style="text-align: center">
    <b> WINDSTORM OR HAIL EXCLUSION</b>
  </p>

  <p class="font-small">
    This endorsement modifies insurance provided under the following:
  </p>
  <br />
  <p class="font-small ps-10">
    CAUSES OF LOSS – BASIC FORM <br />
    CAUSES OF LOSS – BROAD FORM <br />
    CAUSES OF LOSS – SPECIAL FORM <br />
    STANDARD PROPERTY POLICY
  </p>
  <p class="font-small" style="text-align: center"><b>SCHEDULE</b></p>
  <table
    class="font-sm"
    style="width: 100%; border: 1px solid black; border-collapse: collapse"
  >
    <thead>
      <tr>
        <th
          style="
            text-align: center;
            width: 50%;
            border: 1px solid black;
            padding: 5px;
          "
        >
          Premises Number
        </th>
        <th
          style="
            text-align: center;
            width: 50%;
            border: 1px solid black;
            padding: 5px;
          "
        >
          Building Number
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="border: 1px solid black; padding: 5px">&nbsp;</td>
        <td style="border: 1px solid black; padding: 5px"></td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">&nbsp;</td>
        <td style="border: 1px solid black; padding: 5px"></td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">&nbsp;</td>
        <td style="border: 1px solid black; padding: 5px"></td>
      </tr>
      <tr>
        <td colspan="2" style="border: 1px solid black; padding: 5px">
          Information required to complete this Schedule, if not shown above,
          will be shown in the Declarations
        </td>
      </tr>
    </tbody>
  </table>

  <br>
  <table class="font-sm" >
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top">
          With respect to the location(s) indicated in the Schedule, the
          following provisions apply. <br />
          <ol type="A">
            <li style="font-weight: bold; padding-bottom: 10px;">
              <span style="font-weight: normal;">
              The following is added to the <b>Exclusions</b> section and is
              therefore not a Covered Cause of Loss:<br />
              <b>WINDSTORM OR HAIL </b><br />
              We will not pay for loss or damage:
              <ol>
                <li style="font-weight: bold; padding-bottom: 10px;">
                  <span style="font-weight: normal;">
                  Caused directly or indirectly by Windstorm or Hail, regardless
                  of any other cause or event that contributes concurrently or
                  in any sequence to the loss or damage; or
                </span>
                </li>
                <li style="font-weight: bold; padding-bottom: 10px;">
                  <span style="font-weight: normal;">
                  Caused by rain, snow, sand or dust, whether driven by wind or
                  not, if that loss or damage would not have occurred but for
                  the Windstorm or Hail. But if Windstorm or Hail results in a
                  cause of loss other than rain, snow, sand or dust, and that
                  resulting cause of loss is a Covered Cause of Loss, we will
                  pay for the loss or damage caused by such Covered Cause of
                  Loss. For example, if the Windstorm or Hail damages a heating
                  system and fire results, the loss or damage attributable to
                  the fire is covered subject to any other applicable policy
                  provisions.
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top">
          <ol type="A" start="2">
            <li style="font-weight: bold; padding-bottom: 10px;">
              <span style="font-weight: normal;"></span>
              The terms of the Windstorm Or Hail exclusion, or the
              inapplicability of this exclusion to a particular loss, do not
              serve to create coverage for any loss that would otherwise be
              excluded under this policy.
            </li>
            <li style="font-weight: bold; padding-bottom: 10px;">
              <span style="font-weight: normal;">
              Under <b>Additional Coverage – Collapse</b>, in the Causes Of Loss
              – Broad Form, Windstorm or Hail is deleted from Paragraph
              <b>2.a.</b>
            </span>
            </li>
            <li style="font-weight: bold; padding-bottom: 10px;">
              <span style="font-weight: normal;">
              In the Causes Of Loss – Special Form, Windstorm or Hail is deleted
              from the "specified causes of loss".
            </span>
            </li>
            <li style="font-weight: bold; padding-bottom: 10px;">
              <span style="font-weight: normal;">
              Under
              <b>Additional Coverage Extensions – Property In Transit,</b> in
              the Causes Of Loss – Special Form, Windstorm or Hail is deleted
              from Paragraph <b>b.(1).</b>
            </span>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>
